export default __webpack_public_path__ + "9f95489e9de3da0dadab2651cb1b1a03.svg";